export const FormIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg viewBox="0 0 25 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_111_716)">
        <path
          d="M19.2708 22.5332C19.2708 23.0857 19.0513 23.6156 18.6606 24.0063C18.2699 24.397 17.74 24.6165 17.1875 24.6165H2.60415C2.05161 24.6165 1.52171 24.397 1.13101 24.0063C0.740306 23.6156 0.520813 23.0857 0.520813 22.5332V2.74154C0.520813 2.189 0.740306 1.6591 1.13101 1.2684C1.52171 0.877697 2.05161 0.658203 2.60415 0.658203H17.1875C17.74 0.658203 18.2699 0.877697 18.6606 1.2684C19.0513 1.6591 19.2708 2.189 19.2708 2.74154V22.5332Z"
          fill="#00C4B8"
        />
        <path
          d="M14.0625 2.74219H16.1458C16.4221 2.74219 16.687 2.85193 16.8824 3.04728C17.0777 3.24263 17.1875 3.50759 17.1875 3.78385V21.4922C17.1875 21.7685 17.0777 22.0334 16.8824 22.2288C16.687 22.4241 16.4221 22.5339 16.1458 22.5339H3.64579C3.36953 22.5339 3.10457 22.4241 2.90922 22.2288C2.71387 22.0334 2.60413 21.7685 2.60413 21.4922V3.78385C2.60413 3.50759 2.71387 3.24263 2.90922 3.04728C3.10457 2.85193 3.36953 2.74219 3.64579 2.74219H5.72913"
          fill="#C4F0EB"
        />
        <path
          d="M20.7129 5.13653L8.9212 16.918L11.1285 19.1272L22.9202 7.34573L20.7129 5.13653Z"
          fill="#00C4B8"
          stroke="#1E293B"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M24.025 6.24147L22.9167 7.34564L20.7125 5.13731L21.8167 4.03314C21.9611 3.88713 22.1331 3.77122 22.3226 3.69211C22.5121 3.613 22.7155 3.57227 22.9209 3.57227C23.1262 3.57227 23.3296 3.613 23.5191 3.69211C23.7086 3.77122 23.8806 3.88713 24.025 4.03314C24.3154 4.32731 24.4781 4.72399 24.4781 5.13731C24.4781 5.55062 24.3154 5.9473 24.025 6.24147Z"
          fill="#00C4B8"
          stroke="#1E293B"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.9041 3.0776C16.8079 2.97216 16.6908 2.88789 16.5602 2.83014C16.4297 2.7724 16.2885 2.74245 16.1458 2.74219H3.64579C3.36953 2.74219 3.10457 2.85193 2.90922 3.04728C2.71387 3.24263 2.60413 3.50759 2.60413 3.78385V17.3766L16.9041 3.0776Z"
          fill="#F8FAFC"
        />
        <path
          d="M8.92288 16.9199L7.60413 20.4501L11.1343 19.1293L8.92288 16.9199Z"
          fill="#00C4B8"
          stroke="#1E293B"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.6875 12.1169L5.06875 12.8794C5.10442 12.951 5.15662 13.0131 5.22105 13.0606C5.28548 13.108 5.36027 13.1395 5.43926 13.1523C5.51824 13.1651 5.59914 13.1589 5.67528 13.1343C5.75141 13.1097 5.82058 13.0673 5.87708 13.0106L7.8125 11.0752"
          stroke="#1E293B"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.89581 12.1172H10.9375"
          stroke="#1E293B"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.72913 0.658203H14.0625V2.74154C14.0625 3.0178 13.9527 3.28276 13.7574 3.47811C13.562 3.67346 13.2971 3.7832 13.0208 3.7832H6.77079C6.49453 3.7832 6.22957 3.67346 6.03422 3.47811C5.83887 3.28276 5.72913 3.0178 5.72913 2.74154V0.658203Z"
          fill="#C4F0EB"
          stroke="#1E293B"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.6875 7.94987L5.06875 8.71237C5.10442 8.784 5.15662 8.84611 5.22105 8.89357C5.28548 8.94103 5.36027 8.97247 5.43926 8.98529C5.51824 8.99812 5.59914 8.99196 5.67528 8.96732C5.75141 8.94269 5.82058 8.90028 5.87708 8.84362L7.8125 6.9082"
          stroke="#1E293B"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.89581 7.9502H14.0625"
          stroke="#1E293B"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.2708 14.1999V22.5332C19.2708 23.0857 19.0513 23.6156 18.6606 24.0063C18.2699 24.397 17.74 24.6165 17.1875 24.6165H2.60415C2.05161 24.6165 1.52171 24.397 1.13101 24.0063C0.740306 23.6156 0.520813 23.0857 0.520813 22.5332V2.74154C0.520813 2.189 0.740306 1.6591 1.13101 1.2684C1.52171 0.877697 2.05161 0.658203 2.60415 0.658203H17.1875C17.74 0.658203 18.2699 0.877697 18.6606 1.2684C19.0513 1.6591 19.2708 2.189 19.2708 2.74154V3.7832"
          stroke="#1E293B"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.1875 16.2839V21.4922C17.1875 21.7685 17.0777 22.0334 16.8824 22.2288C16.687 22.4241 16.4221 22.5339 16.1458 22.5339H3.64579C3.36953 22.5339 3.10457 22.4241 2.90922 22.2288C2.71387 22.0334 2.60413 21.7685 2.60413 21.4922V3.78385C2.60413 3.50759 2.71387 3.24263 2.90922 3.04728C3.10457 2.85193 3.36953 2.74219 3.64579 2.74219H5.72913"
          stroke="#1E293B"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.0625 2.74219H16.1458C16.4221 2.74219 16.6871 2.85193 16.8824 3.04728C17.0778 3.24263 17.1875 3.50759 17.1875 3.78385V5.86719"
          stroke="#1E293B"
          strokeWidth="1.04167"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_111_716">
          <rect width={25} height={25} fill="white" transform="translate(0 0.137695)" />
        </clipPath>
      </defs>
    </svg>
  );
};
